// extracted by mini-css-extract-plugin
export default {"container":"create-report_container__IfPg-","input":"create-report_input__VkvU8","modalContent":"create-report_modalContent__v5LKG"};